import React, { useContext, useEffect, useState } from "react";

import { Button, Form, FormGroup, FormLabel } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { ErrorAlert } from "../../Components/ErrorAlert";
import { Field, FormikProvider, useFormik } from "formik";
import Building from "../../Services/buildingService";
import Floor from "../../Services/floorServices";
import { Toast } from "primereact/toast";
import { useRef } from "react";
import { AuthContext } from "../../Auth/Context/AuthContext";
import TitleHeader from "../accounts/Components/TitleHeader";
function AddFloor(props) {
  const { edit } = props;
  const { user } = useContext(AuthContext);
  const floorId = useParams().id;

  const [error, setError] = useState(false);
  const [buildings, setBuildings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [floorRecord, setFloorRecord] = useState(false);
  const toast = useRef(null);
  const getBuildings = async () => {
    setLoading(true);
    Building.getAll()
      .then((data) => {
        console.log(
          "BBBBBBBBBBBBBBBBBBBBBBuildings",
          data.data.data.buildings.map((building) => {
            return { label: building.name, value: building._id };
          })
        );
        setBuildings(
          data.data.data.buildings.map((building) => {
            return { label: building.name, value: building._id };
          })
        );
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const getFloorEdit = async () => {
    if (edit && floorId) {
      setLoading(true);
      await Floor.getOne(floorId)
        .then((data) => {
          console.log("Updating Floor", data.data);
          setFloorRecord(data.data);
          setLoading(false);
        })
        .catch((err) => {
          setError(true);
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    getBuildings();
    if (floorId) {
      getFloorEdit();
    }
  }, []);
  const navigate = useNavigate();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      floorNumber: floorRecord?.floorNumber || "",
      area: floorRecord?.area || "",
      feePerSquareMeter: floorRecord?.feePerSquareMeter || "",
      freeSpace: floorRecord?.freeSpace || "",
    },
    onSubmit: (values, { setSubmitting, setFieldError }) => {
      setLoading(true);
      values.branchId = user.branchId;
      if (floorId) {
        values.id = parseInt(floorId);
        Floor.update(values)
          .then((data) => {
            setLoading(false);
            if (data.data.status === "Fail") {
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: data.data.message,
                life: 3000,
              });
              return;
            }
            toast.current.show({
              severity: "success",
              summary: "Success",
              detail: data.data.message,
              life: 3000,
            });
            navigate("/floor-list");
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
          });
      } else
        Floor.addFloor(values)
          .then((data) => {
            setLoading(false);
            if (data.data.status === "Fail") {
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: data.data.message,
                life: 3000,
              });
              return;
            }
            toast.current.show({
              severity: "success",
              summary: "Success",
              detail: data.data.message,
              life: 3000,
            });
            navigate(`/floor-details/${data.data.id}`);
          })
          .catch((err) => {
            setLoading(false);
            console.log(err);
          });
    },
  });
  const {
    errors,
    touched,
    isSubmitting,
    handleSubmit,
    setFieldValue,
    handleChange,
  } = formik;

  return (
    <>
      {loading && (
        <div id="global-loader">
          <div class="whirly-loader"> </div>
        </div>
      )}
      <div class="page-wrapper">
        <Toast ref={toast} />
        <div class="content">
          <TitleHeader title="Add Floor" />

          <div class="card">
            <div class="card-body">
              <FormikProvider value={formik}>
                <Form onSubmit={handleSubmit}>
                  <FormGroup className="mb-3">
                    <div class="row">
                      <div class="col-lg-3 col-sm-6 col-12">
                        <div class="form-group">
                          <FormLabel>Floor Number</FormLabel>
                          <Field type="number" name="floorNumber" required />
                        </div>
                      </div>

                      <div class="col-lg-3 col-sm-6 col-12">
                        <div class="form-group">
                          <FormLabel>Fee per Square Meter</FormLabel>
                          <Field type="number" name="feePerSquareMeter" />
                        </div>
                      </div>

                      <div class="col-lg-3 col-sm-6 col-12">
                        <div class="form-group">
                          <FormLabel>Area (Square Meter)</FormLabel>
                          <Field type="number" name="area" required />
                        </div>
                      </div>
                      {floorId && (
                        <div class="col-lg-3 col-sm-6 col-12">
                          <div class="form-group">
                            <FormLabel>Free Space</FormLabel>
                            <Field type="number" name="freeSpace" required />
                          </div>
                        </div>
                      )}
                      <div class="col-lg-12">
                        <Button className="btn btn-submit me-2" type="submit">
                          Save
                        </Button>
                        <Button href="/floor-list" className="btn btn-cancel">
                          Cancel
                        </Button>
                      </div>
                    </div>
                  </FormGroup>
                </Form>
              </FormikProvider>
              {error && <ErrorAlert heading={"Floor not found"}></ErrorAlert>}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddFloor;
